import React, { useContext } from 'react';
import Cleave from 'cleave.js/react';
import { FormGroup, Label } from 'reactstrap';
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.i18n';
import useTranslation from '../../contexts/LanguageTranslation/useTranslation';

/**
 *  FOR USE IN ALL CASES OF PHONE NUMBERS. CANNOT TRANSLATE INSIDE COMPONENT.
 *  MUST PASS TRANSLATED STRINGS FROM PARENT IF TRANSLATION NEEDED.
 */

const PhoneNumberInput = ({
    fieldName,
    label,
    error, // pass this.validator.message( FIELDNAME, VALUE, RULE)
    onChange = () => {},
    value
}) => {
    const language = useTranslation();
    const {
        country,
        countryVars: { phone }
    } = language;

    const handleInput = (e) => {
        // TODO: use e.target.rawValue and stripPrefix props (cleave options) to get JUST the number without country code.
        console.log('=== e.target.value, e.target.rawValue ===', e.target.value, e.target.rawValue);
    };
    const cleaveOptions =
        country === 'US'
            ? {
                  blocks: [0, 3, 0, 3, 4],
                  delimiters: ['(', ')', ' ', '-'],
                  numericOnly: true
              }
            : {
                  prefix: phone.countryCode,
                  phone: true,
                  phoneRegionCode: country
              };

    return (
        <FormGroup>
            <Label
                htmlFor={fieldName}
                className='form-label'
            >
                {label}
            </Label>
            <span
                aria-hidden='true'
                className='required-indicator'
            >
                *
            </span>
            <Cleave
                id={fieldName}
                name={fieldName}
                className='form-control'
                type='tel'
                autoComplete='tel'
                aria-required='true'
                value={value}
                onChange={onChange}
                options={cleaveOptions}
            />
            {!!error && error}
            {/* 
                // THIS IS WHAT YOU SHOULD PASS TO ERROR FROM PARENT:
                {this.validator.message("contactPhone", this.state.contactPhone, "required|phone")} 
            */}
        </FormGroup>
    );
};

export default PhoneNumberInput;
